export enum AvailabilityHours {
  NineToThree,
  ThreeToNine,
}
